export default __webpack_public_path__ + "static/Inter-Regular-e89cb19905e7db5591b0037b15a1d9cd.ttf";